import React from 'react';
import Base from './Base';

type ButtonProps = React.ComponentProps<typeof Base>;

const Tertiary: React.FC<ButtonProps> = ({ className, ...rest }) => {
    const classes = ['btn--tertiary', className].filter(Boolean).join(' ');
    return <Base className={classes} {...rest} />;
};

export default Tertiary;
